import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { HistoryFacade } from '../history-entries';
import { WorkspaceFacade } from '../workspace';
import { ChatMessage } from './design.models';
import { DesignActions } from './design.actions';
import { selectDesignChatMessages, selectDesignError, selectDesignLoading } from './design.selectors';

@Injectable({ providedIn: 'root' })
export class DesignFacade {
  private store = inject(Store);
  private workspace = inject(WorkspaceFacade);
  private history = inject(HistoryFacade);

  readonly chatMessages = toSignal(this.store.select(selectDesignChatMessages), { initialValue: [] as ChatMessage[] });
  readonly loading = toSignal(this.store.select(selectDesignLoading), { initialValue: false });
  readonly error = toSignal(this.store.select(selectDesignError), { initialValue: null });
  readonly activeProjectId = this.workspace.activeProjectId;

  load(): void {
    this.store.dispatch(DesignActions.load());
  }
  setChatMessages(messages: ChatMessage[]): void {
    this.store.dispatch(DesignActions.setChatMessages({ messages }));
  }
  async logChatEvent(text: string, kind: 'user' | 'assistant' | 'info' | 'update' | 'error' = 'info'): Promise<void> {
    const projectId = this.activeProjectId();
    if (!projectId) return;
    await this.history.add(projectId, 'design.chat', text, kind as any);
  }
}
